import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {ResellerGroupsListHeader} from './components/header/ResellerGroupsListHeader'
import {ResellerGroupsTable} from './table/ResellerGroupsTable'
import { ResellerGroupEditModal } from './ResellerGroup-edit-modal/ResellerGroupEditModal'
import {KTCard} from '../../../../_metronic/helpers'

const ResellerGroupsList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <ResellerGroupsListHeader />
        <ResellerGroupsTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <ResellerGroupEditModal />}
    </>
  )
}

const ResellerGroupsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ResellerGroupsList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {ResellerGroupsListWrapper}
